import { TranslateLoader } from "@ngx-translate/core";
import { Observable } from "rxjs";
declare var System: any;
export class CustomLoader implements TranslateLoader {
    getTranslation(lang: string): Observable<any> {
      let promise = (<any>System).import(`../../../assets/i18n/${lang}.json`);
        return Observable.create((observer:any) => {
            promise
                .then((o: any) => { observer.next(o); observer.complete(); })
                .catch((e: any) => observer.error(e));
        });
    }
}
